import { atom } from '@exodus/jotai';
import { loadable as baseLoadable } from '@exodus/jotai/utils';
const cache1 = new WeakMap();
const memo1 = (create, dep1) => (cache1.has(dep1) ? cache1 : cache1.set(dep1, create())).get(dep1);
export const loadable = (anAtom) => {
    return memo1(() => {
        const loadableAtom = baseLoadable(anAtom);
        return atom((get) => {
            const loadableValue = get(loadableAtom);
            const hasError = loadableValue.state === 'hasError';
            const loading = loadableValue.state === 'loading';
            return {
                loading,
                data: loading || hasError ? null : loadableValue.data,
                error: hasError ? loadableValue.error : null,
            };
        });
    }, anAtom);
};
